import { useState } from 'react';

import useScreenSize from '@/hooks/useScreenSize';
import { formatArtworkTitleForDisplay } from '@/pages/artwork/utils/artworkTitleDisplay.utils';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericBottomSheet from '@/shared-components/popups/components/GenericBottomSheet';
import Text from '@/shared-components/text/components/Text';
import TextHandler from '@/shared-components/text/components/TextHandler';

import "./styles/ArtworkTitle.css";

const ArtworkTitle = ({ artworkData }) => {
  const [showText, setShowText] = useState(false);
  const screenSize = useScreenSize();
  const threshold = calculateThreshold();
  const displayTitle = formatArtworkTitleForDisplay(artworkData?.artwork_about?.artwork_title) || '-';
  
  function calculateThreshold() {
    if(screenSize.width <= 370) return 60;
    if(screenSize.width <= 400) return 65;
    if(screenSize.width <= 450) return 88;
    if(screenSize.width <= 520) return 100;
    if(screenSize.width <= 610) return 153;
    if(screenSize.width <= 680) return 170;
    else return 200;
  }
  return (
    <>
      <TextHandler
        className="artwork-label__title" 
        text={displayTitle}
        controlsClassName="artwork-view-artwork-title__more-button" 
        maxCharactersWhenCollapsed={threshold} 
        moreControlClick={()=>{setShowText(true);}} 
        
      />
      <GenericBottomSheet
        open={showText} 
        close={() => setShowText(false)} 
        className="artwork-view-artwork-title-bottom-sheet" 
        onTouchStart={e => e.stopPropagation()} 
        onTouchEnd={e => e.stopPropagation()} 
        onWheel={e => e.stopPropagation()}
      >
        <div className="artwork-view-artwork-title-bottom-sheet__content remove-scrollbar">
          <div className="artwork-view-artwork-title-bottom-sheet__content-header">
            <XIcon className="artwork-view-artwork-title-bottom-sheet__close" onClick={() => setShowText(false)}/>
          </div>

          <Text
            className="artwork-view-artwork-title-bottom-sheet__text font-size-large"
            paragraph
            justify>
            {displayTitle}
          </Text>
        </div>
      </GenericBottomSheet>
    </>
  );
};

export default ArtworkTitle;
